export default __webpack_public_path__ + "static/media/star.50b1a695.svg";